import { useDocumentHead } from '@/lib/hooks/use-document-head'

interface PageMetaProps {
  title?: string
  description?: string
  keywords?: string[]
  ogImage?: string
  ogType?: 'website' | 'article'
  noIndex?: boolean
}

export function PageMeta(props: PageMetaProps) {
  useDocumentHead(props)
  return null
}
